import { render, staticRenderFns } from "./GridButton.vue?vue&type=template&id=1d86c215&"
import script from "./GridButton.vue?vue&type=script&lang=js&"
export * from "./GridButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports